export function bestpartnerListGet(page) {
	return {
    type: 'BESTPARTNER_LIST_GET',
		payload: {
			page: page,
		},
	}
}



export function bestpartnerRead(mailId) {
	return {
    type: 'BESTPARTNER_READ',
		payload: {
			mailId: mailId,
		},
	}
}

export function bestpartnerItemDel(mailId) {
	return {
    type: 'BESTPARTNER_ITEM_DEL',
		payload: {
			mailId: mailId,
		},
	}
}
